import React, { Component } from "react";

import { Wrapper, Title, Copy, Button, Row } from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import { openUrl } from "app/NativeActions";

class OnboardingText extends Component {
  renderLearnMoreButton() {
    if (this.props.secondaryButtonText && this.props.secondaryButtonLink) {
      return (
        <PillButton
          onPress={() => {
            openUrl(this.props.secondaryButtonLink);
          }}
        >
          <Copy>{this.props.secondaryButtonText}</Copy>
        </PillButton>
      );
    }
  }

  render() {
    if (
      this.props.plan_module_info.canceled != 1 &&
      this.props.plan_module_info.paused != 1 &&
      this.props.card_info.bad_card != 1 &&
      (this.props.plan_module_info.team_has_module == false ||
        this.props.plan_module_info.tier < this.props.require_tier) &&
      (this.props.plan_module_info.approved_to_charge == 1 ||
        this.props.plan_module_info.selected_plan == false ||
        this.props.plan_module_info.is_trial_over == false ||
        this.props.plan_module_info.is_trial_over == null) &&
      this.props.platform !== "ios"
    ) {
      return (
        <Wrapper
          style={{
            alignItems: !this.props.center ? "flex-start" : "center",
            justifyContent: !this.props.center ? "flex-start" : "center"
          }}
        >
          <Wrapper
            style={{
              alignItems: !this.props.center ? "flex-start" : "center",
              justifyContent: !this.props.center ? "flex-start" : "center",
              marginBottom: 10
            }}
          >
            <Title
              style={{
                textAlign: !this.props.center ? "left" : "center",
                marginBottom: 10
              }}
            >
              {this.props.onboarding_title}
            </Title>
            <Copy style={{ textAlign: !this.props.center ? "left" : "center" }}>
              {this.props.onboarding_text}
            </Copy>
          </Wrapper>
          <Row
            style={{
              justifyContent: this.props.center ? "center" : "flex-start"
            }}
          >
            <PillButton
              primary={true}
              style={{ marginLeft: this.props.center ? 5 : 0 }}
              onPress={() => {
                this.props.setPricingPage({
                  title: "Purchase Engine",
                  engine_slug: this.props.slug,
                  tier: this.props.require_tier ? this.props.require_tier : 1,
                  frequency: "annually"
                });
                this.props.togglePricingPage(true);
              }}
            >
              {this.props.primaryButtonText}
            </PillButton>

            {this.renderLearnMoreButton()}
          </Row>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}
export default OnboardingText;
